export default "__VITE_ASSET__C23ujz7r__"